import {CmsContent} from "../../Model/CmsContent/CmsContent";
import React from "react";
import HeaderFooterWrapper from "../../Components/Navigation/HeaderFooterWrapper";
import {BannerTitle, Section, Title, Text, Button, Banner, Circle} from "./RafPageComponents";
import {sessionStorageRafKey} from "./RafPage";
import {SALES_PORTAL_ROUTES} from "../../Routes/SalesPortalRoutes";
import {ApplicationContext} from "../../ApplicationContext";
import raf_lady_1 from "../../assets/raf/raf_lady_1.png";
import raf_lady_2 from "../../assets/raf/raf_lady_2.png";

interface RafPageErrorProps {
    readonly cmsContent: CmsContent[]
}
const SuperdrugRafPageError = (props: RafPageErrorProps): JSX.Element => {

    const applicationContext = React.useContext(ApplicationContext)

    React.useEffect(() => {
        sessionStorage.removeItem(sessionStorageRafKey)
    }, [])

    return (
        <HeaderFooterWrapper cmsContent={props.cmsContent}>
            <React.Fragment>
                <Banner>
                    <div className="container m-md-auto">
                        <div className="row h-100 w-100">
                            <div className="col-8" style={{display: "flex"}}>
                                <div className="row" style={{alignItems: "center"}}>
                                    <BannerTitle>{"You've been invited to\njoin Superdrug Mobile!"}</BannerTitle>
                                </div>
                            </div>
                            <div className="col p-0 d-flex align-items-end" style={{position: "relative"}}>
                                    <img src={raf_lady_1} style={{zIndex: "2"}} alt={"raf_lady_1"}/>
                                    <Circle>
                                        {"Save\nUp to\n£12"}
                                    </Circle>
                            </div>
                            <div className="col p-0 d-flex align-items-end">
                                    <img src={raf_lady_2} style={{zIndex: "2"}} alt={"raf_lady_2"}/>
                            </div>
                        </div>
                    </div>
                </Banner>
                <div className={"mw-md ms-auto me-auto p-4"}>
                    <Section>
                        <Title>...but it looks like this unique link is no longer valid</Title>
                        <Text>
                            {"The link has either been used already or has expired."}
                        </Text>
                        <Text>
                            {"Get a new unique link to become a Superdrug Mobile customer and\n" +
                                "both you and the friend that referred you can save 20% each."}
                        </Text>
                        <a>See terms and conditions for details</a>
                    </Section>
                    <Section>
                        <Title>Can't wait to join up?</Title>
                        <Text>
                            {"If you don't want to wait for another unique link to get 20% off,\n" +
                                "then simply join Superdrug Mobile with the button below."}
                        </Text>
                    </Section>
                    <Section>
                        <Button href={SALES_PORTAL_ROUTES.Login(applicationContext.urlContext)}>Join now</Button>
                    </Section>
                </div>
            </React.Fragment>
        </HeaderFooterWrapper>
    )
}

export default SuperdrugRafPageError